/** App md breakpoint, used for shell behaviors that remain desktop-only. */
export const OS_DESKTOP_MEDIA_QUERY = '(min-width: 900px)';

export type OsWindowVariant = 'default' | 'fullscreen';

export interface OsRouteMeta {
  variant: OsWindowVariant;
  /** Routes in the same group retain one window while their content changes. */
  windowGroup?: string;
  /** Reserved for the future split-pane desktop experience. */
  panel?: 'left' | 'right';
  /** Which nav variant the shell renders over this window (default: study). */
  navMode?: 'study' | 'faculty';
  /** Page name shown in the window header (default windows only). */
  title?: string;
  /**
   * Centers the exam/preclinical selectors in this window's header. Only the
   * Dashboard opts in; every other surface leaves exam switching to the
   * desktop strip.
   */
  hasExamSelectors?: boolean;
  /**
   * Drops the window header below the OS breakpoint. The Dashboard's is
   * nothing but its own name there — no back, no panel menu — and the bottom
   * nav already says where you are. Every other window keeps its bar at every
   * width (maximize and close drop out sub-md; see _os-shell.scss).
   */
  hidesMobileHeader?: boolean;
}

export interface OsRouteHandle {
  os?: OsRouteMeta;
}

/**
 * Logic-heavy study-session surfaces (fullscreen study layout) where the OS
 * desktop is not mounted underneath — the window covers the viewport, so the
 * desktop's chat tree would be pure overhead. The AI drawer skin is a
 * separate concern, derived from the route variant (see ContextualAiDrawer).
 */
export const isStudyRoute = (pathname: string): boolean =>
  pathname.startsWith('/study');
